export default __webpack_public_path__ + "static/logo-64-48bebfdff2a8f9c391fac89e335c5dcd.png";